<template>
    <div>
        <CCol sm="12" class="bg-white position-relative">
            <div class="text-center">
                <br /><br />
                <CCard class="border-EAECF0">
                    <div class="p-3">
                        <img src="../assets/img/pc.png" style="max-width:150px" />
                        <img src="../assets/img/tq.png" style="max-width:150px" class="mt-2"/>
                        <label class="font-color-696969 mt-3">We appreciate you taking the time to share your thoughts. Your feedback helps us improve and deliver a better experience for you! 🚀
Stay tuned for more updates!</label>
                    </div>
                </CCard>
                <CRow class="p-2">
                    <div style="width:60%" class="p-1 text-right" @click="GoPickiddo()">
                        <img src="../assets/img/pickiddo.png" style="max-width:95%" />
                    </div>
                    <div style="width:40%" class="p-1 text-left">
                        <img src="../assets/img/sport.png" style="max-width:85%" @click="GoSport()"/>
                        <br />
                        <img src="../assets/img/genie.png" style="max-width:85%" class="mt-2"  @click="GoGenie()"/>
                    </div>
                    <div style="width:50%" class="p-1 text-right" @click="GoInterviewrr()">
                        <img src="../assets/img/interviewrr.png" style="max-width:91%" />
                    </div>
                    <div style="width:50%" class="p-1 text-left" @click="GoInterviewrr()">
                        <img src="../assets/img/dashbord-interviewrr.png" style="max-width:90%" />
                    </div>
                </CRow>
                <br /><br />  <br /><br />
    
                <!-- Button positioned at the bottom -->
                <CButton class="custom-border-purple text-white p-2 homepage-btn" block style="width:80%" @click="GoHomepage()">
                    Homepage
                </CButton>
            </div>
        </CCol>
    </div>
</template>
  


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundPhone from "../assets/img/bgphone.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/HeaderQR.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import ToggleCard from "../components/Toggle.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import { Html5Qrcode } from "html5-qrcode";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundPhone,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopup: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {},
            showConfirmationDialog: false,
            cameraAccessDenied: false,
            Error: false,
            user: {},
            userId: "",
            email: "",
            Message: "",
            showStartSurvey: false,
            showMain: true,
            showScanner: false,
            qrResult: null,
            qrScanner: null,



        };
    },
    async created() {
        AOS.init();
    },
    async mounted() {
        await this.getFirstQuestion();
    },
    methods: {

        toggle() {
            this.isActive = !this.isActive;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoPickiddo()
        {
            window.open("https://campus.pickiddo.com/");

        },
        GoSport()
        {
            window.open("https://sportcenter.pro/")
        },
        GoInterviewrr()
        {
            window.open("https://www.interviewrr.ai/")
        },
        GoGenie()
        {
            window.open("https://genieworkers.com/")
        },
        GoHomepage()
        {
            this.$router.push("Home");
        }
       


    },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
    top: 0 !important;
    font-family: "General Sans", sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}

@media (max-width: 768px) {
    .popup-all1 {
        width: 90%;
        max-width: 500px;
        padding: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 20px;
        z-index: 1000;
        margin: 0 auto;
        margin-top: 50%;
    }
}

#qr-reader {
    width: 100%;
    max-width: 400px;
    max-height: 500px;
    margin: 0 auto;
}

.full-height {
    height: 100%;
    width: 100%;
}
</style>
